import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// https://gsap.com/docs/v3/Plugins/ScrollTrigger/

// El принимает data атрибут data-media="(max-width: 1280px)",
// если передается, то анимация будет только в указанный диапазон

/* eslint-disable */
export const useScrollOverlap = (
    el: HTMLElement, // Элемент который прилипнет к началу элемента offsetEL
    lastEl?: HTMLElement,
    offsetEL: HTMLElement = document.querySelector('.j-header')!,
    offset: number = 0,
    anticipatePin: number = 0.5 // https://gsap.com/docs/v3/Plugins/ScrollTrigger/#anticipatePin
): void => {
    const widthDataSet = el.dataset['media'] || null;

    const parentEl = el.parentElement as HTMLElement;

    // Последний элемент, который будет наезжать на el.
    // Если между el и lastEl есть другие элементы, то нужно им задать в css relative и z-index выше чем el
    lastEl = lastEl || parentEl?.querySelector('.j-overlap-second') as HTMLElement;

    if (!lastEl) {
        console.error('No lastEl found for overlap');
        return;
    }

    lastEl.style.position = 'relative';
    lastEl.style.zIndex = el.style.zIndex + 1;

    const offsetHeight = offsetEL.offsetHeight + offset;
    const fixedHeight = offsetHeight + el.offsetHeight;
    const windowHeight = window.innerHeight;
    const heightDifference = fixedHeight > windowHeight ? fixedHeight - windowHeight : 0;

    const scrollTriggerOptions: ScrollTrigger.StaticVars = {
        trigger: el,
        start: `top ${offsetHeight - heightDifference}`,
        endTrigger: lastEl,
        end: `top ${offsetHeight}`,
        pin: true,
        pinSpacing: false,
        anticipatePin,
    };

    if (widthDataSet) {
        gsap.matchMedia().add(widthDataSet, () => {
            const scrollTrigger = ScrollTrigger.create(scrollTriggerOptions);

            return () => {
                scrollTrigger.kill();
            };
        });
    } else {
        ScrollTrigger.create(scrollTriggerOptions);
    }
};
